// Libraries
import React, { useState } from 'react'
import * as yup from 'yup'

// Hooks
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

// Layouts
import { MainWrapperWithCaptions } from '../../layouts/MainWrapperWithCaptions'
import Progress from '../../components/Progress'
import { TextDescription, WrapFormContent } from '../StageOne/WrapFormContent'
import { Option, Select, WrapSelect } from '../../ui/Select'
import { Input } from '../../ui/Input/index'
import { Button } from '../../ui/Button'
import { ArrowLeft, TextButton } from '../../ui/TextButton'
import { WrapInput } from '../../ui/Input/style'

interface IProps {
  currentStage: number;
  setStageAndToTop: (arg0: number) => void;
  appendData: (arg0: object) => void;
}

interface IFormInputs {
  zipCode: string;
  city: string;
  country: number;
}

const SignupSchema = yup
  .object({
    zipCode: yup.string().required('Dieses Feld ist erforderlich').matches(/[\d]/, 'Postleitzahl Nummer ist ungültig'),
    city: yup.string().required('Dieses Feld ist erforderlich').matches(/^[A-Za-z]+$/i, 'Geben Sie den gültigen Namen ein'),
    country: yup.number(),
  })
  .required();

export const StageThree = ({ currentStage, setStageAndToTop, appendData  }: IProps) => {
  const { register: fromRegister, handleSubmit: fromHandleSubmit, reset: fromReset, formState: { errors } } = useForm<IFormInputs>( {resolver: yupResolver(SignupSchema)} )

  const onFromHandleSubmit = (body: object) => {
    appendData(body)
    fromReset()
    setStageAndToTop(4)
  }

  const countries = [
    "Deutsch", "Englisch", "Franzoesich", "Spanisch", "Italienisch", "Kroatisch", "Griechisch", "Polnisch", "Russisch", "Holländisch", "Finnisch", "Chinesisch", "Koreanisch", "Japanisch", "Hebräisch", "Bosnisch", "Serbisch", "Bulgarisch", "Portugiesisch", "Türkisch", "Tschechisch", "Dänisch", "Estnisch", "Ungarisch", "Lettisch", "Litauisch", "Mexikanisch", "Norwegisch", "Slowakisch", "Slowenisch", "Schwedisch", "Arabisch", "Ukrainisch", "Thai"
  ]

  return (
    <>
      <MainWrapperWithCaptions stage={currentStage}
                               title={<>Bitte nenne uns noch<br /> Deinen Wohnort</>}
                               key={3}
                               textAlign='left'>
        <Progress stage={currentStage} />
      </MainWrapperWithCaptions>
      <WrapFormContent onSubmit={fromHandleSubmit(onFromHandleSubmit)}>
        <WrapInput>
          <WrapSelect>
            <Select {...fromRegister('country')}>
              {countries.map((title, index) => <Option value={index} key={index}>{title}</Option>)}
            </Select>
          </WrapSelect>
          <Input placeholder='Postleitzahl*' {...fromRegister('zipCode')} errorMessage={errors?.zipCode?.message}  isError={errors?.zipCode !== undefined} />
          <Input placeholder='Stadt*' {...fromRegister('city')} errorMessage={errors?.city?.message}  isError={errors?.city !== undefined} />
        </WrapInput>
        <TextDescription>*Morbi sed bibendum ut commodo lorem. Viverra malesuada sit sed ut amet quam mi.</TextDescription>
        <Button arrow>Weiter</Button>
        <TextButton onClick={() => setStageAndToTop(2)}>
          <ArrowLeft width="10" height="21" viewBox="0 0 10 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 1L0.999999 10.5L9 20" stroke="white" strokeWidth="1.5"/>
          </ArrowLeft>
          Zurück
        </TextButton>
      </WrapFormContent>
    </>
  )
}
